import { Pipe, PipeTransform } from "@angular/core";
import { NsEmpWebExpData } from "../../models/emp-web-exp.model";
@Pipe({
  name: "mealStyle"
})
export class MealStylePipe implements PipeTransform {
  transform(
    mealMap: Map<string, NsEmpWebExpData.IMealMapType>,
    selectedItem: NsEmpWebExpData.IMeal,
    typeName: NsEmpWebExpData.IMealOption,
    meal: NsEmpWebExpData.IMealsEntity
  ) {
    const response =
      mealMap.size > 0 &&
      mealMap.has(meal.mealId) &&
      mealMap.get(meal.mealId).premiseId === selectedItem.premiseId &&
      Object.values(mealMap.get(meal.mealId).mealSelection)?.[0] === typeName.value;
    return response;
  }
}
